<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-grid-section>
    <dgx-components-grid-container>
      <dgx-components-grid-row>
        <dgx-components-grid-column>
          <h1 class="ineligible__title">
            {{ vm.cmsData.pageTitle }}
          </h1>

          <dgx-components-alert
            [body]="vm.cmsData.ineligibleAlertPanel.body | cmsContent"
            [highlight]="'error'"
            [title]="vm.cmsData.ineligibleAlertPanel.title"
            class="ineligible__alert-panel"
          />
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>
  </dgx-components-grid-section>

  <div [content]="main" editable-area></div>
</ng-container>
